export default function Personal() {
  return (
    <div className="roboto-regular">
      <p className="pt-4 italic text-[#00adef] text-lg text-white">
        Your First 30 Days Are FREE – Start Seeing Results Fast!
      </p>
      <ul className="list-disc pl-6 py-3 text-white">
        <li className="py-1 text-xl">
          Access to over 200 live & on demand BFR workouts
        </li>
        <li className="py-1 text-xl">
          Access to BFR masterclasses and educational series
        </li>
        <li className="py-1 text-xl">
          Join a community focused on fitness, recovery & motivation
        </li>
      </ul>
      <p className="text-[#00adef] text-lg text-white">
        After 30 days, your subscription will automatically renew at
        $29.99/month. Cancel anytime by contacting{" "}
        <a
          href="mailto:support@b3sciences.com"
          className="block text-[#00adef]"
        >
          support@b3sciences.com
        </a>
      </p>
    </div>
  );
}
